import { VERSION } from "./version";
console.log(`current version: ${VERSION}`);

/* empty function */
export const helloTravis = () => {
  return "hello";
};
